




















































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {currency} from "@/util/formatter";
import ModalTrigger from "@/components/modal/ModalTrigger.vue";
import axios from 'axios';

@Component
export default class MonthlyProgress extends Vue {
    @Prop()
    currentAmount!: number;

    @Prop()
    targetAmountProp!: number;

    amountEntryError: string | null = null;
    isUpdatingMonthlyProgress: boolean = false;
    targetAmount: number = this.targetAmountProp;
    enteredMonthlyAmount: number = this.targetAmountProp;

    @Watch('enteredMonthlyAmount')
    onEnteredMonthlyAmountChanged(newVal: number, oldVal: number) {
        this.amountEntryError = null;
    }

    mounted() {
        window.addEventListener('resize', this.onResizeEvent);
        this.onResizeEvent();
    }

    beforeDestroy() {
        window.removeEventListener('resize', this.onResizeEvent);
    }

    onResizeEvent() {
        const progressTextOuter = document.getElementById('progress-text-outer');
        const progressOuter = document.getElementById('progress-outer');
        const progressTextInner = document.getElementById('progress-text-inner');
        if (progressTextOuter && progressOuter && progressTextInner) {
            const progressTextOuterStyle = window.getComputedStyle(progressTextOuter);
            const progressWidth = progressOuter.offsetWidth - parseInt(progressTextOuterStyle.marginRight);
            progressTextInner.setAttribute('style', `width: ${progressWidth}px`);
        }
    }

    editMonthlyProgress() {
        if (this.isUpdatingMonthlyProgress) {
            return;
        }

        const modal = this.$refs.modal as ModalTrigger;
        if (this.enteredMonthlyAmount > 0) {
            this.amountEntryError = null;

            this.isUpdatingMonthlyProgress = true;
            axios.post(
                '/my-account/updateMonthlyTargetAmount',
                {
                    'targetAmount' : this.enteredMonthlyAmount
                })
            .then(response => {
                this.targetAmount = response.data.targetMonthlyAmount;
                this.enteredMonthlyAmount = this.targetAmount;
                modal.closeModal();

                this.$nextTick(() => {
                    this.onResizeEvent();
                });
            })
            .catch(error => {
                // TODO: show toast message?
                console.error(error);
            })
            .finally(() => {
                this.isUpdatingMonthlyProgress = false;
            });
        } else {
            this.amountEntryError = "You must enter a value higher than 0.";
        }
    }

    get formattedCurrentAmount(): string {
        return currency(this.currentAmount);
    }

    get formattedTargetAmount(): string {
        return currency(this.targetAmount);
    }

    get percentage(): number {
        return Math.min((this.currentAmount / this.targetAmount) * 100, 100);
    }

    get hasTargetSet(): boolean {
        return this.targetAmount > 0;
    }

    get progressClass(): string {
        if (!this.hasTargetSet) {
            return 'inactive';
        }

        const progress = this.percentage;

        if (progress <= 50) {
            return "low";
        } else if (progress <= 80) {
            return "medium";
        }

        return "full";
    }
}
